import axios from "axios";

export default () => {
  return axios.create({
    //baseURL: "http://192.168.1.8:3000/api.php/",
    baseURL: "https://gdicpl.com/",
    headers: {
      //"Access-Control-Allow-Origin": "*",
      //"Content-Type": "application/json",
      // "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    },
  });
};
